<template>
  <BaseModalWindow
    :title="selectBaseModalWindowTitle()"
    @closeModal="closeAddTagsModal"
  >
    <div class="add-tags">
      <div class="tags">
        <div class="tags__input">
          <div class="tags__input-item">
            <p>Название тега:</p>
            <InputText
              ref="Name"
              style="width: 100%; height: 42px;"
              placeholder="Введите название тега"
              type="text"
              v-model="selectTagName"
            />
          </div>

          <div class="tags__input-item">
            <p>Направление деятельности:</p>
            <Dropdown
              v-if="dropdownActive"
              ref="Id"
              style="width: 100%; text-align: start; height: 42px;"
              v-model="selectDirection"
              :options="addTagsData"
              optionLabel="Description"
              placeholder="Направление деятельности"
            />
          </div>
        </div>
        <div class="tags__buttons">
          <BaseBtnNew
            :disabled="validForm"
            :blue="true"
            name="Сохранить"
            @click="submitTags"
          >
            <SaveIconNew/>
          </BaseBtnNew>
          <!-- <BaseBtn
          @click="closeAddTagsModal"
          :blue="true"
          text="Отменить"
          /> -->
        </div>
      </div>
    </div>
  </BaseModalWindow>
</template>

<script>
import { useStore } from 'vuex'
import { ref, onMounted, computed } from 'vue'
import BaseModalWindow from '@/components/modals/BaseModalWindow.vue'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import BaseBtnNew from '@/components/ui/BaseBtnNew.vue'
import SaveIconNew from '@/components/icons/SaveIconNew.vue'

export default {
  name: 'AddTagsModal',
  components: {
    BaseModalWindow,
    InputText,
    Dropdown,
    BaseBtnNew,
    SaveIconNew
  },
  props: {
    categoryId: {
      type: Number,
      default: null
    },
    dropdownActive: {
      type: Boolean,
      default: true
    },
    tagsEducation: {
      type: Boolean,
      default: false
    },
    keywordsEducation: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const store = useStore()

    const selectBaseModalWindowTitle = () => {
      if ((localStorage.activeProject === 'site' && props.dropdownActive) || (localStorage.activeProject === 'education' && props.tagsEducation)) {
        return 'Новый тег внутренней навигации'
      } else if (!props.dropdownActive) {
        return 'Добавление ключевого слова'
      }
    }

    const selectDirection = ref(null)

    const selectTagName = ref('')

    onMounted(() => {
      if (localStorage.activeProject === 'site') {
        store.dispatch('setAddTagsData')
      }
    })

    const submitTags = () => {
      if (localStorage.activeProject === 'site') {
        if (props.dropdownActive === true) {
          const obj = {
            Name: selectTagName.value,
            UniversalTagId: selectDirection.value.Id,
            Category: props.categoryId
          }
          store.dispatch('setPostTags', obj)
        } else {
          const obj = {
            Name: selectTagName.value,
            Category: props.categoryId
          }
          store.dispatch('setPostKeywords', obj)
        }
      } else if (localStorage.activeProject === 'education') {
        const obj = {
          Name: selectTagName.value
        }
        if (props.tagsEducation) {
          store.dispatch('setPostTagsEducation', obj)
        } else if (props.keywordsEducation) {
          store.dispatch('setPostKeywordsEducation', obj)
        }
      }
      store.commit('SetShowAddTagsEditor', false)
    }

    const addTagsData = computed(() => {
      return store.getters.getAddTagsData
    })

    const validForm = computed(() => {
      if (props.dropdownActive === true) {
        if (selectTagName.value === '' || selectDirection.value === null) {
          return true
        } else {
          return false
        }
      } else if (props.dropdownActive === false) {
        if (selectTagName.value === '') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    })

    const closeAddTagsModal = () => {
      store.commit('SetShowAddTagsEditor', false)
    }

    return {
      selectBaseModalWindowTitle,
      selectDirection,
      selectTagName,
      submitTags,
      addTagsData,
      validForm,
      closeAddTagsModal
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-tags {
    width: 710px;
    height: 240px;
  }

  .change-tags {
    width: 710px;
    height: 240px;
  }

  .tags {
    margin-top: 40px;

    &__input {
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;
      gap: 30px;
      margin-bottom: 40px;

      &-item {
        width: 100%;
        text-align: left;
        font-weight: 500;
        font-size: 18px;
        line-height: 1.4;
      }
    }

    &__buttons {
      display: flex;
      justify-content: center;
      gap: 24px;
    }
  }

  :deep(.base-button) {
    width: 200px;
  }
</style>
